/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  preparer_user_id: z.string().uuid(),
  deleted_at: z.number().nullable(),
  remarks: z.string().nullable(),
  created_by_user_id: z.string().uuid(),
});
const create = base.extend({
  remarks: base.shape.remarks.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
  created_by_user_id: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
  created_by_user_id: true,
})
.extend({ id: z.string().uuid() });
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
  preparer_user_id: true,
  created_by_user_id: true,
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const IssuanceBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type IssuanceBase = z.infer<typeof base>;
export type IssuanceBasePutPayload = z.infer<typeof put>;
export type IssuanceBasePatchPayload = z.infer<typeof patch>;
export type IssuanceBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type IssuanceBaseCreateAttributes = z.infer<typeof create>;
export type IssuanceBaseUpdateAttributes = z.infer<typeof update>;
export type IssuanceBaseCacheAttributes = z.infer<typeof cache>;
export type IssuanceBaseCachesAttributes = z.infer<typeof caches>;